import { render, staticRenderFns } from "./SubscriptionsNav.vue?vue&type=template&id=55aeaa04&"
import script from "./SubscriptionsNav.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports